module.exports = __webpack_public_path__ + "static/media/Ahmed_Farag_CV_PM.c0d69ccc.pdf";